module.exports = __webpack_public_path__ + "img/facebook-f_b.bfb4e4d7.svg";